module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-group-item clearfix b-l-3x",
    style: ({
      'border-left-color': _vm.mail.tipo && _vm.tipos[_vm.mail.tipo.id] && _vm.tipos[_vm.mail.tipo.id].color
    })
  }, [_c('div', {
    staticClass: "pull-right text-sm text-muted"
  }, [_c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.mail.data.date)))])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }, [_c('div', [_c('router-link', {
    staticClass: "text-md",
    class: {
      'not-read': !_vm.mail.lido
    },
    attrs: {
      "to": {
        name: 'view-email',
        params: {
          id: _vm.mail.id
        }
      }
    }
  }, [_vm._v(_vm._s(_vm.mail.assunto) + " | "), _c('small', [_vm._v(_vm._s(_vm.mail.nome))]), _vm._v(" "), _c('sup', [_vm._v("#" + _vm._s(_vm.mail.id))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "text-ellipsis m-t-xs"
  }, [_vm._v(_vm._s(_vm.mail.mensagem))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-058fd6a0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/contatos/components/EmailItem.vue
// module id = 1649
// module chunks = 18